"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconButton_module_css_1 = __importDefault(require("./IconButton.module.css"));
/**
 * Styled component used to render circular icon links
 */
function IconLink(props) {
    const { children, label, title, href, onClick, dataTest } = props;
    return ((0, jsx_runtime_1.jsx)("a", { className: IconButton_module_css_1.default.button, "aria-label": label, title: title, href: href, onClick: onClick, "data-testid": dataTest, children: children }));
}
exports.IconLink = IconLink;
//# sourceMappingURL=IconLink.js.map